export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[680px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20luxurious%20dark%20ambient%20abstract%20background%20with%20flowing%20golden%20ribbon%20waves%20and%20warm%20amber%20light%20streaks%2C%20premium%20and%20elegant%20atmosphere%2C%20subtle%20geometric%20patterns%2C%20dark%20charcoal%20base%20with%20rich%20golden%20highlights%2C%20sophisticated%20and%20trustworthy%20aesthetic%2C%20suitable%20for%20a%20premium%20platform%20website%20hero%20background&width=1800&height=900&seq=hero-bg-52662&orientation=landscape"
        alt="52662鼎盛平台官方版"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60" />

      <div className="relative z-10 w-full h-full flex items-center">
        <div className="max-w-7xl mx-auto px-4 md:px-6 w-full">
          <div className="max-w-3xl">
            <div className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-primary-500/20 border border-primary-500/30 mb-6">
              <i className="ri-verified-badge-fill text-primary-400 text-sm" />
              <span className="text-primary-200 text-xs font-medium">官方认证正版平台</span>
            </div>

            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-5">
              52662鼎盛平台
              <span className="block text-primary-400 mt-2 text-2xl md:text-4xl lg:text-5xl">
                安全稳定 · 值得信赖
              </span>
            </h1>

            <p className="text-white/70 text-sm md:text-base leading-relaxed max-w-xl mb-8">
              官方正版认证平台，累计服务500万+用户。提供极速访问通道、专属会员权益与
              全天候客服支持，让每一次体验都安心无忧。
            </p>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
              <a
                href="#download"
                className="whitespace-nowrap px-8 py-3.5 rounded-full text-sm font-semibold bg-primary-500 text-background-50 hover:bg-primary-400 transition-all duration-300 cursor-pointer inline-flex items-center gap-2"
              >
                <i className="ri-download-line text-lg" />
                官方正版下载
              </a>
              <a
                href="#register"
                className="whitespace-nowrap px-8 py-3.5 rounded-full text-sm font-semibold border border-white/30 text-white hover:bg-white/10 hover:border-white/50 transition-all duration-300 cursor-pointer inline-flex items-center gap-2"
              >
                <i className="ri-user-add-line text-lg" />
                立即注册
              </a>
            </div>

            <div className="flex items-center gap-5 mt-8">
              <div className="flex items-center gap-1.5">
                <i className="ri-shield-check-fill text-primary-400 text-sm" />
                <span className="text-white/60 text-xs">官方正版</span>
              </div>
              <div className="flex items-center gap-1.5">
                <i className="ri-lock-fill text-primary-400 text-sm" />
                <span className="text-white/60 text-xs">安全保障</span>
              </div>
              <div className="flex items-center gap-1.5">
                <i className="ri-customer-service-2-fill text-primary-400 text-sm" />
                <span className="text-white/60 text-xs">全天候服务</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="animate-bounce">
          <i className="ri-arrow-down-s-line text-white/40 text-2xl" />
        </div>
      </div>
    </section>
  );
}